export interface ceOffersData {
  placementIdentifier: string;
  offerType: string;
  offerDescription: string;
  dismissText: string;
  source: string;
  cta: {
    afterLinkIcon: string;
    ctaText: string;
    ctaType: string;
    ctaValue: string;
    dataUiElementName: string;
    dataUiSectionName: string;
    openNewWindow: boolean;
  };
  logo: string;
  offerId: string;
  offerName: string;
  offerToken: string;
  MPCode: string;
}

export interface CeOffersState {
  ceOffersData: Array<ceOffersData>;
  setCeOffersData: (ceOffersData: Array<ceOffersData>) => void;
  clearCeOffersData: () => void;
}

export enum StoreKeys {
  CE_OFFERS_DATA = 'ceOffersData',
  SET_CE_OFFERS_DATA = 'setCeOffersData',
  CLEAR_CE_OFFERS_DATA = 'clearCeOffersData',
}

export const initialState = {
  [StoreKeys.CE_OFFERS_DATA]: [],
};
